import { useFormikContext } from 'formik'
import { path } from 'ramda'
import { useEffect, useMemo } from 'react'
import { useDebounce } from 'usehooks-ts'

import type { Path } from 'ramda'

type FormListenerProps = {
  onChange: (values: Record<string, unknown>, isValid: boolean, errors?: Record<string, unknown>) => void
  fields: Path[]
  errors?: Record<string, unknown>
}

const FormListener = ({ onChange, fields, errors }: FormListenerProps) => {
  const { values, isValid } = useFormikContext<Record<string, unknown>>()

  const watchedFields = useMemo(() => {
    return fields.map((field) => path(field, values))
  }, [JSON.stringify(fields), values])

  const debouncedWatchedFields = useDebounce(watchedFields, 200)

  useEffect(() => {
    onChange(values, isValid, errors)
  }, [debouncedWatchedFields, isValid, errors])

  return null
}

export type { FormListenerProps }
export { FormListener }
